import { render, staticRenderFns } from "./AccrualsEstimates.vue?vue&type=template&id=0be1df92&scoped=true"
import script from "./AccrualsEstimates.vue?vue&type=script&lang=js"
export * from "./AccrualsEstimates.vue?vue&type=script&lang=js"
import style0 from "./AccrualsEstimates.vue?vue&type=style&index=0&id=0be1df92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be1df92",
  null
  
)

export default component.exports